import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Checkbox from 'src/app/components/Checkbox';
import {
  accountFormRegulationsChange
} from 'src/app/redux/actions/registration/account/accountFormAgreementsRegulations';
import 'src/app/containers/Registration/Account/AccountFormAgreementsRegulationsContainer.scss';
import TextExpander from 'src/app/components/TextExpander';


class AccountFormAgreementsRegulationsContainer extends React.PureComponent {

  onChange = (event) => {
    const { checked, validationMessage } = event.target;
    const { dispatch } = this.props;

    dispatch(accountFormRegulationsChange(checked, validationMessage));
  };

  render() {
    const { onChange } = this;
    const { validationMessage, checked, inputRef, sending } = this.props;

    const primaryText = <span styleName="required-field">
      Akceptuję <a
      href="https://grupapracuj.pl/grupa-kapitalowa/regulamin/"
      styleName="regulation-link"
      title="Zobacz regulamin"
      rel="noopener noreferrer"
      target="_blank">Regulamin</a>, żeby utworzyć i korzystać z bezpłatnego konta w serwisie
      Pracuj.pl.
    </span>;

    const secondaryText = `Zakładając konto, zawieram z Grupą Pracuj sp. z o.o., właścicielem serwisu Pracuj.pl,
    umowę o świadczenie usługi konta i związanym z nim funkcjonalności. Zgadzam się,
    żeby Pracuj.pl przesyłał mi rekomendowane oferty pracy na mój adres e-mail
    lub poprzez powiadomienia w aplikacji mobilnej.`;

    return (
      <Checkbox required
                disabled={ sending }
                ref={ inputRef }
                data-test="checkbox-regulation"
                { ...{ checked, validationMessage, onChange } }
      >
        <TextExpander { ...{ primaryText, secondaryText } } />

        <p styleName="additional-explanation">
          W ramach bezpłatnej usługi konto Pracuj.pl, portal Pracuj.pl będzie mi przesyłać rekomendowane oferty pracy,
          dopasowane do moich potrzeb. Zawsze mogę z nich zrezygnować w ustawieniach mojego konta (zakładka Prywatność).
        </p>
      </Checkbox>
    );
  }
}

AccountFormAgreementsRegulationsContainer.propTypes = {
  validationMessage: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};


const mapStateToProps = store => ({
  ...store.accountFormRegulationsReducer,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormAgreementsRegulationsContainer);
